import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { Checkbox } from 'Components/Form/Checkbox'
import React, { useContext, useState } from 'react'
import { SnackBarContext } from '../../../../../../../Components/SnackBar'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import QRCodePopup from '../../Popups/QRCodePopup'
import styles from './styles'

const InternalCodesTable = ({
  codes,
  classes,
  setSelectedRows,
  selectedRows,
  countCodesLinks,
  disabled,
}) => {
  const [selectedLink, setSelectedLink] = useState(null)
  if (!codes) return null

  const runSnackBar = useContext(SnackBarContext)

  const handleShowToast = () => {
    runSnackBar({
      type: 'success',
      msg: 'Link copied to clipboard',
    })
  }

  return (
    <React.Fragment>
      <QRCodePopup
        isOpen={!!selectedLink}
        onCancel={() => {
          setSelectedLink(null)
        }}
        content={selectedLink}
      />
      <div className={classes.table}>
        <div className={classes.row} key={`code-row_header`}>
          <div className={classes.index} />
          <div className={classes.tableRow}>
            <div className={cn(classes.tableCell, classes.checkboxBlock)}>
              <Checkbox
                input={{
                  onChange: () => {
                    const set = new Set()
                    if (selectedRows.length !== codes.length) {
                      codes.forEach(row => {
                        set.add(row.id)
                      })
                    }
                    setSelectedRows(Array.from(set))
                  },
                  value: selectedRows.length === codes.length,
                  disabled,
                }}
                shouldListenToInputValue
              />
            </div>
            <div className={cn(classes.tableCell, classes.code)}>
              FLYER CODE
            </div>
            <div className={cn(classes.tableCell, classes.city)}>CITY</div>
            <div className={cn(classes.tableCell, classes.qrCodeColumn)}>
              QR
            </div>
          </div>
        </div>
        {codes.map((codeRow, index) => {
          return (
            <div className={classes.row} key={`code-row_${codeRow.id}`}>
              <div className={classes.index}>{index + 1}</div>
              <div className={classes.tableRow}>
                <div className={cn(classes.tableCell, classes.checkboxBlock)}>
                  <Checkbox
                    input={{
                      onChange: () => {
                        const set = new Set(selectedRows)
                        if (selectedRows.includes(codeRow.id)) {
                          set.delete(codeRow.id)
                        } else {
                          set.add(codeRow.id)
                        }
                        setSelectedRows(Array.from(set))
                      },
                      value: selectedRows.includes(codeRow.id),
                      disabled,
                    }}
                    shouldListenToInputValue
                  />
                </div>
                <div
                  className={cn(
                    classes.tableCell,
                    classes.code,
                    countCodesLinks.codes[codeRow.internalCode] > 1
                      ? classes.highlight
                      : '',
                  )}
                >
                  {codeRow.internalCode}
                </div>
                <div className={cn(classes.tableCell, classes.city)}>
                  {codeRow.city.name}
                </div>
                <div className={cn(classes.tableCell, classes.qrCodeColumn)}>
                  <Button
                    variant="outlined"
                    size="small"
                    className={classes.button}
                    onClick={() => {
                      setSelectedLink(codeRow.internalLink)
                    }}
                  >
                    QR Code
                  </Button>

                  <CopyToClipboard text={codeRow.internalLink}>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleShowToast}
                    >
                      Copy URL Link
                    </Button>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </React.Fragment>
  )
}

export default React.memo(withStyles(styles)(InternalCodesTable))
